const tracklinkOrigin = (): string => {
  const origin = import.meta.env.VITE_TRACKLINK_ORIGIN;
  if (!origin) throw new Error("VITE_TRACKLINK_ORIGIN is required");
  return origin.replace(/\/$/, "");
};

export const isTracklinkNumber = (value: string): boolean => {
  const normalized = value.trim().toUpperCase();
  return (
    /^EZ\d{14}A[1-9]$/.test(normalized) ||
    /^EZ[0-9A-HJKMNP-TV-Z]{16}$/.test(normalized)
  );
};

export const tracklinkRedirectUrl = (
  trackingNumber: string,
  search = ""
): string | null => {
  const normalized = trackingNumber.trim().toUpperCase();
  if (!isTracklinkNumber(normalized)) return null;
  const query = search.startsWith("?") || search === "" ? search : `?${search}`;
  return `${tracklinkOrigin()}/${normalized}${query}`;
};
